import { Button } from "@/components/ui/button";
import { Megaphone } from "lucide-react";

// Stile uniforme per tutti i funnel del software: pulsante verde smeraldo + megafono.
export const FUNNEL_BTN_CLASS = "border-emerald-500/50 text-emerald-600 hover:bg-emerald-500/10 dark:text-emerald-400";

export default function FunnelTriggerButton({ label, onClick, size = "sm", className = "", ...props }) {
  return (
    <Button size={size} variant="outline" onClick={onClick} className={`${FUNNEL_BTN_CLASS} ${className}`} {...props}>
      <Megaphone className="mr-2 h-4 w-4" /> {label}
    </Button>
  );
}
